const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/gamification/points/manage.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/gamification/points/manage")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Points Management",
      description: "Page title for the points management path"
    })
  }
});